import type { PayableSummary, ReceivableSummary } from "./invoicingTypes";
import { PayableList } from "./PayableList";
import { PayableShow } from "./PayableShow";
import { ReceivableList } from "./ReceivableList";
import { ReceivableShow } from "./ReceivableShow";

/**
 * Almikia Epic E6 (TASK-040): the `receivables` resource. List and show only:
 * receivables are never created or edited through the API (the RPCs write).
 */
export default {
  list: ReceivableList,
  show: ReceivableShow,
  recordRepresentation: (record: ReceivableSummary) =>
    `${record.operation_id} · ${record.installment_number}`,
};

/** Almikia Epic E6 (TASK-041): the `payables` resource, list and show only. */
export const payables = {
  list: PayableList,
  show: PayableShow,
  recordRepresentation: (record: PayableSummary) =>
    `${record.operation_id} · ${record.payee_name ?? ""}`,
};

export { VoboPendingPage } from "./VoboPendingPage";
